// Safe mode by country: the countries that get the non-explicit site (safeCountries), and the
// account uids exempt from it (safeCountriesWhitelist; AuthContext sets role=whitelisted).

export const safeCountries = ['NZ']

export const safeCountriesWhitelist = [
  'UOetKqaIj5TQdltaxfpmiOzwK1M2',
  'alvUBw24gLUAc7pqklvaxhnsIci1',
  '4YkvIpPSSXeTgKIMg6OjE5SjT072',
  'PZihzBYLojUil11YSI7QgRCPK8F3',
  'c6p5dVvF2yNL1bqR44dr3IL2hu43',
  'A1S0ND0HvHeqaOKyd4yBSxq6ETA2',
  '0P32oCXUj9NhurkOmSZXCN2lOnE2',
  'gvVK8wnnPHYcSawMjUb5aSY05G12',
  'DKJXeF8cYPYIUlmeafQUvzsYCAy2',
  //users
  'eXI2aakxZsdZTSVc6HPpn4wEtwk2',
  'FGSs8kN1athRoG7rSPumuKXsVmk2',
  'hv1YikHQ11hsgs7PeeGzED4Wmhi1',
  'fc3F5iDmBBXt8R8dJqBvVcaIduD3',
  'HQ4NU0c4HBbxMBVAjn5ofUrg3IF2',
  'sgy8GnYY4uY5rr2lWt25I6szAR92',
  'JkHGtgOE0PQm81YunnsEKXHpT9w1',
  'NYqfRq1CZUN8vrbY3d9Jve2968H2',
  'L2uS8FkCA0Xki20bMuwWxbNVACs2',
  'n4OSxbEoO0dxpq8tCTFdtY6rwwv1',
  'GkLo0s0EAjdbrZFLaIwf0q0gyMj2',
  'ea38n2uSYLRqEFEqPA3KUMTKObp2',
  'r2JY87pCs2RfcpXgO2e6klcJD4z1',
  'W6rHnZuz07QIwkk7pvXaCMdOTlD3',
  'LLdojGWj27ajvmnUaKAAw6YAsX93',
  '6GZ3YIxMTeXoHvKTEwTAJp4mwll2',
  'ubLGj1QU9rXsexO5wnnznjFbWg62',
  'YWiHuqRliHUwjZpliYth5igeoDg1',
  'ES0ctQYgYcNAh6WjI3Rcp8SEToX2',
  'FXqlGqLeREOThYrEutNNdgbGMD62',
  '0CNmkmjuEkhaQKn9YbVewVWixvM2',
  'nu3YFwCozrh1S4W680mACfqP4MS2',
  'bf3VuO1S6aV5xHYAhInFfSKRWb73',
  'zLHlAKRktjYJnL0aSQ8Rnbn0Pmv1',
  'xGQkYWI6OLP8s1mrpyKWQ1MxVse2',
  'AVTwTs9TBjf9rIymD5E4Y3H4F142',
  'QSszdSBdb3VOU6KRLhDA5G3KBp23',
  'YXP1MtKyjehLjcsEYlVI6SK7R8j1',
]
